import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "mask0_11078_5506",
      style: {"mask-type":"alpha"},
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "20",
      height: "20"
    }, [
      _createElementVNode("rect", {
        width: "20",
        height: "20",
        fill: "#D9D9D9"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#mask0_11078_5506)" }, [
      _createElementVNode("path", {
        d: "M8.25299 14.4229L3.83008 9.99979L8.25299 5.57666L8.84279 6.17604L5.4357 9.58312H16.1697V10.4165H5.4357L8.84279 13.8235L8.25299 14.4229Z",
        fill: "white"
      })
    ], -1)
  ])))
}
export default { render: render }